 <div class="row" style="padding-top: 5px;">
     <div class="col-lg-12">
         <div class="m-portlet m-portlet--unair">
             <div class="m-portlet__head">
                 <div class="m-portlet__head-caption">
                     <div class="m-portlet__head-title">
                         <h3 *ngIf="custodianInfo?.CustodianInformation" class="m-portlet__head-text"
                             style="font-size: 20pt;font-weight: normal;">
                           {{differentLoggedIn ? ('CUSTODIAN' | dictionary) : (('WELCOME' | dictionary) + ', ')}} {{custodianInfo.CustodianInformation.CustodianName}}
                         </h3>
                     </div>
                 </div>
                 <span class="m-portlet__head-caption" *ngIf="InboxCount > 0">
                     <h5 style="color: #fff; text-decoration: underline;cursor: pointer; font-size: 14px;"
                         (click)="navigateToUnReadMsg()">
                         ({{InboxCount}}) {{'NEW_MESSAGES' | dictionary}}
                     </h5>
                 </span>
             </div>
           <app-announcement-block [announcements]="Announcements"></app-announcement-block>
         </div>
     </div>
 </div>


 <app-portfolio-block [userInfo]="custodianInfo"
                      [user]="custodianInfo?.CustodianInformation"  [label]="'CUSTODIAN' | dictionary"  [differentLoggedIn]="differentLoggedIn"></app-portfolio-block>

 <div class="row">
   <app-documents-block class="col-lg-6" [label]="'CUSTODIAN' | dictionary"  [statements]="statements"  [differentLoggedIn]="differentLoggedIn"
                        [communications]="communications" [taxes]="taxes"></app-documents-block>

     <div class="col-lg-6">
       <app-forms-block [forms]="forms" [label]="'CUSTODIAN' | dictionary" [differentLoggedIn]="differentLoggedIn"></app-forms-block>
       <app-contacts [contacts]="contacts"></app-contacts>
     </div>

 </div>

 <div class="row">

 </div>

 <app-pop-up-dialog [Message]="alertmessage" [Display]="display" (DisplayBack)="onConfirm()">

 </app-pop-up-dialog>
